export const resolveTimeout = (timeout, resolveWith) => new Promise((resolve, _reject) => {
  setTimeout(resolve, timeout, resolveWith);
});
export const rejectTimeout = (timeout, rejectWith) => new Promise((_resolve, reject) => {
  setTimeout(reject, timeout, rejectWith);
});